import { Component, Inject } from '@angular/core';
import { EOCommentDetail } from '../../../../modal/entity.modal';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FnToasterService, FnUtilService } from 'foundation';
import { PosHttpService } from '../../../../services/pos.http.service';

@Component({
  selector: 'app-hist-info-model',
  templateUrl: './hist-info-model.component.html',
  styleUrl: './hist-info-model.component.scss'
})
export class HistInfoModelComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: HwDialogData, private dialogRef: MatDialogRef<HistInfoModelComponent>, private toaster: FnToasterService, private posHttpSvcs: PosHttpService){}
  
  commentArr: EOCommentDetail[] = [];

  ngOnInit(): void {
    this.loadComments();
  }

  loadComments(): void {
      this.posHttpSvcs.authPost('v1/ui/getCommentHist', 'getCommentHist', this.dialogData.extraInfo).subscribe((resp: { isError: string; data: EOCommentDetail[]; }) => {
        if (resp.isError) {
          this.toaster.error("EOCommentArray is not loaded");
        }
        this.commentArr = resp.data;
      }
      );
    }

  close() {
    this.dialogRef.close();
  }

}

interface HwDialogData {
  extraInfo: any;
}

